import React, { useCallback } from 'react';
import * as slice from "../../store/questionBank/questionBankSlice";
import * as courseSlice from "../../store/course/courseSlice";
import { useAppDispatch, useAppSelector } from "../../store/hook";
import { questionBankActions } from '../../store/questionBank/questionBankSlice';
import { courseActions } from '../../store/course/courseSlice';

export const useQuestionBank = () => {
    const dispatch = useAppDispatch();
    return {
        loadQuestions: useCallback((payload) => {
            dispatch(questionBankActions.loadQuestionBank(payload));
        }, [dispatch]),
        loadCourseQuestions: useCallback((payload) => {
            dispatch(questionBankActions.loadCourseQuestion(payload));
        },[dispatch]),
        loadCurrent: useCallback((payload) => {
            dispatch(questionBankActions.loadCurrentQuestion(payload));
        }, [dispatch]),
        save: useCallback((payload) => {
            dispatch(questionBankActions.saveCurrentQuestion(payload));
        }, [dispatch]),
        create: useCallback((payload) => {
            dispatch(questionBankActions.createQuestion(payload));
        }, [dispatch]),
        remove: useCallback((payload) => {
            dispatch(questionBankActions.removeQuestion(payload));
        }, [dispatch]),
        updateStatus: useCallback((payload) => {
            dispatch(questionBankActions.updateStatus(payload));
        }, [dispatch]),
        loadCourses: useCallback((payload) => {
            dispatch(courseActions.loadCourses(payload));
        }, [dispatch]),
        loadSection: useCallback((payload) => {
            dispatch(questionBankActions.loadSection(payload));
        }, [dispatch]),
        loadChapter: useCallback((payload) => {
            dispatch(questionBankActions.loadChapter(payload));
        }, [dispatch]),
        loadGroup: useCallback((payload) => {
            dispatch(questionBankActions.loadGroup(payload));
        }, [dispatch]),
        loadLessonPlan: useCallback((payload) => {
            dispatch(courseActions.loadLessonPlan(payload));
        }, [dispatch]),

        questionsList: useAppSelector(slice.getQuestionBank),
        courseQuestions: useAppSelector(slice.getCourseQuestion),
        current: useAppSelector(slice.getCurrentQuestion),
        loading: useAppSelector(slice.isLoading),
        pagination: useAppSelector(slice.getPagination),
        courseList: useAppSelector(courseSlice.getCourses),
        sectionList: useAppSelector(slice.getSection),
        chapterList: useAppSelector(slice.getChapter),
        groupList: useAppSelector(slice.getGroup),
        lessonPlan: useAppSelector(courseSlice.getLessonPlan),

    }
}